<template>
    <div class="top-bar-container">
        <div class="topbar" :class="customClass">
            <div class="topbar-wrapper">
                <div class="topbar-left">
                    <slot  v-if="hasLeftSlot"  name="left" />
                    <router-link v-else :to="backUrl" class="back-link">
                        <img src="/assets/images/icon/icon-back.svg" alt="戻る" />
                    </router-link>
                </div>
                <div v-if="hasCenterSlot" class="topbar-center">
                    <slot name="center" />
                </div>
                <div v-else class="topbar-center">
                    {{ title }}
                </div>
                <div class="topbar-right">
                    <slot name="right" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'TopBar',
    props: {
        title: {
            type: String,
            default: '',
        },
        backUrl: {
            type: String,
            default: '',
        },
        customClass: {
            type: String,
            default: '',
        },
    },
    computed: {
        hasLeftSlot() {
            return !!this.$slots.left;
        },
        hasCenterSlot() {
            return !!this.$slots.center;
        },
        hasRightSlot() {
            return !!this.$slots.right;
        },
    },
};
</script>
